import lodash from 'lodash';
import { compute } from '@exodus/atoms';
const { get: getValueAtPath } = lodash;
export const createRemoteConfigAtomFactory = ({ remoteConfig }) => createRemoteConfigComputeAtomFactory({ remoteConfigAtom: remoteConfig.remoteConfigAtom });
export const createRemoteConfigComputeAtomFactory = ({ remoteConfigAtom }) => ({ defaultValue, ...params }) => {
    if ('path' in params && 'selector' in params) {
        throw new Error('Provide either a path or a selector to get data from remote config - not both.');
    }
    return compute({
        atom: remoteConfigAtom,
        selector: (value) => 'path' in params
            ? getValueAtPath(value.config, params.path, defaultValue)
            : (params.selector(value.config) ?? defaultValue),
    });
};
